import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import {
  UiMoleculeDialogUserProfileComponent,
  UserProfileData,
  UserProfileResult,
} from '@shared/components/molecules/ui-molecule-dialog-user-profile/ui-molecule-dialog-user-profile.component';

@Injectable({
  providedIn: 'root',
})
export class DialogUserProfileService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly translate: TranslateService,
  ) {}

  /**
   * Abre el diálogo de perfil de usuario
   */
  openUserProfile(): Promise<UserProfileResult> {
    const data: UserProfileData = {
      title: this.translate.instant('userProfile.title'),
      message: this.translate.instant('userProfile.message'),
    };

    const dialogRef = this.dialog.open<
      UiMoleculeDialogUserProfileComponent,
      UserProfileData,
      UserProfileResult
    >(UiMoleculeDialogUserProfileComponent, {
      width: '90vw',
      maxWidth: '700px',
      maxHeight: '90vh',
      autoFocus: 'first-tabbable',
      data,
      disableClose: false,
      panelClass: ['dialog-md', 'dialog-safe-area'],
    });

    return dialogRef.afterClosed().toPromise() as Promise<UserProfileResult>;
  }
}
